module.exports = __webpack_public_path__ + "img/vector.5ce3a57f.svg";